import styled from 'styled-components'
import newTabIcon from '../assets/images/link-new-tab-icon.svg'

const Link = styled.a`
  cursor: pointer;

  ${props =>
    props.target === '_blank'
      ? `
  &:after {
    display: inline-block;
    content: '';
    background-image: url(${newTabIcon});
    width: 12px;
    height: 12px;
    margin-left: 8px;
  }
  `
      : ``}
`

export default Link
